/**
 * How empty trajectory cells are handled on import (agentic tasks, "Does your
 * data contain trajectories? = Yes"). Sent as `empty_trajectory_handling` on
 * upload / clone. Mirrors `emptyResponsesHandling.js` for the response column.
 */

/** Keep the row; it stays without a trajectory (and is not used for training). */
export const EMPTY_TRAJECTORIES_UNLABELED = 'unlabeled';
/** Generate the reasoning path and answer for the row with the teacher model. */
export const EMPTY_TRAJECTORIES_GENERATE_WITH_AI = 'generate_with_ai';
/** Drop the row at import time. */
export const EMPTY_TRAJECTORIES_EXCLUDE = 'exclude';

export const EMPTY_TRAJECTORIES_DEFAULT = EMPTY_TRAJECTORIES_UNLABELED;

export const EMPTY_TRAJECTORIES_HANDLING_VALUES = [
    EMPTY_TRAJECTORIES_UNLABELED,
    EMPTY_TRAJECTORIES_GENERATE_WITH_AI,
    EMPTY_TRAJECTORIES_EXCLUDE,
];

/** True when the choice means "fill empty trajectories with AI". */
export function isEmptyTrajectoryGenerateWithAi(value) {
    return value === EMPTY_TRAJECTORIES_GENERATE_WITH_AI;
}

/** Radio options for the "How should empty trajectory values be handled?" section. */
export function emptyTrajectoryOptions({ includeGenerateWithAi = true } = {}) {
    const unlabeled = {
        value: EMPTY_TRAJECTORIES_UNLABELED,
        title: 'Leave empty',
        description:
            'Import without a trajectory. These samples are excluded from training until they have one.',
    };
    const generateWithAi = {
        value: EMPTY_TRAJECTORIES_GENERATE_WITH_AI,
        title: 'Generate the reasoning path and answer with AI',
        description:
            'Generate the reasoning path and answer with AI (the original answer is kept as a reference).',
    };
    const exclude = {
        value: EMPTY_TRAJECTORIES_EXCLUDE,
        title: 'Exclude from import',
        description: 'Skip rows that do not contain a trajectory.',
    };
    return includeGenerateWithAi ? [unlabeled, generateWithAi, exclude] : [unlabeled, exclude];
}

/** Title / description / tooltip copy for the section. */
export function emptyTrajectorySectionCopy() {
    return {
        title: 'How should empty trajectory values be handled?',
        description:
            'In case of empty trajectory values in your trajectory column, choose how to treat these samples.',
        tooltip:
            'Choose how to treat rows whose trajectory column is empty (missing, blank, or an empty message list).',
    };
}
